import { render, staticRenderFns } from "./OrderSliderProduct.vue?vue&type=template&id=371e6220&scoped=true&"
import script from "./OrderSliderProduct.vue?vue&type=script&lang=js&"
export * from "./OrderSliderProduct.vue?vue&type=script&lang=js&"
import style0 from "./OrderSliderProduct.vue?vue&type=style&index=0&id=371e6220&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371e6220",
  null
  
)

export default component.exports